module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e21-8d4c155eceff6e488a37e5185927f7df.jpg";